// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c0531cf7","389":"bb1e77a8","455":"caaae213","977":"12baf707"}[chunkId] + ".chunk.js";
};